import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLoaderData } from 'react-router';
import { AuthCard } from '../AuthCard.js';
import type { ResultatEtiquette } from './ouvrirEtiquetteLoader.js';

/** Ce que voit celui dont le scan ne mène à aucune fiche (le reste redirige). */
export function OuvrirEtiquettePage(): JSX.Element {
  const { t } = useTranslation('regie');
  const { raison } = useLoaderData<ResultatEtiquette>();
  return (
    <AuthCard title={t('etiquettes.scan.titre')}>
      <p role="status">{t(`etiquettes.scan.${raison}`)}</p>
      <Link to="/">{t('etiquettes.scan.accueil')}</Link>
    </AuthCard>
  );
}
